import React, { useEffect, useState } from "react";
import {
  DataGrid,
  GridColDef,
  GridToolbarExport,
  koKR,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarColumnsButton,
  GridToolbarQuickFilter,
  GridFooterContainer,
} from "@mui/x-data-grid";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import axios from "axios";
import { koKR as corekoKR } from "@mui/material/locale";
import { Box, Typography } from "@mui/material";
import CustomPagination from "../../component/common/CustomPagination";
import { koKRGrid } from "../../component/common/TableKRText";

function CustomToolbar(props: any) {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarExport
        csvOptions={{
          utf8WithBom: true,
        }}
      />
      <GridToolbarQuickFilter sx={{ marginLeft: "auto" }} />
    </GridToolbarContainer>
  );
}

const columns: GridColDef[] = [
  { field: "id", headerName: "id", width: 70 },
  { field: "email", headerName: "이메일", width: 200 },
  { field: "name", headerName: "이름", width: 80 },
  { field: "origin_name", headerName: "원본이름", width: 230 },
  { field: "new_name", headerName: "새이름", width: 230 },
  { field: "file_dir", headerName: "파일위치", width: 200 },
  { field: "upload_date", headerName: "업로드 날짜", width: 100 },
  { field: "ins_date", headerName: "업로드 시간", width: 200 },
];

const theme = createTheme(
  {
    palette: {
      primary: { main: "#1976d2" },
    },
    typography: {
      fontFamily: "Gmarket"
    }
  },
  koKR,
  corekoKR
);

export interface rowDetailType {
  id: number;
  email: string;
  name: string;
  origin_name: string;
  new_name: string;
  file_dir: string;
  upload_date: string;
  ins_date: string;
}

export interface pageInfoType {
  current_page: number;
  total_pages: number;
}

const FileInfoTable = (props: any) => {
  const [page, setPage] = useState(1);
  console.log("test::",props.path)
  const [rows, setRows] = useState([]);
  const [rowDetail, setRowDetail] = useState<rowDetailType>({
    id: 0,
    email: "",
    name: "",
    origin_name: "",
    new_name: "",
    file_dir: "",
    upload_date: "",
    ins_date: "",
  });
  // api 사용자 정보에서 페이지 정보를 담을 state
  const [pagination, setPagination] = useState<pageInfoType | undefined>(
    undefined
  );

  const dirData = props.path.split("/");
  const workValue= dirData[1]
  const dateValue= dirData[2]
  const userValue= dirData[3]
  
  console.log("일",workValue)
  console.log("시간",dateValue)
  console.log("사람",userValue)
  // 팝업 관리 state

  const getUploadFileList = async (path:any) => {
    var result = await axios.get("http://localhost:9680/uploadFileList",
      {params: { page: page, path: path }});

    var datas = result.data.datas.map((data: any) => {
      return {
        id: data.idx,
        email: data.worker_email,
        name: data.worker_name,
        origin_name: data.origin_file_name,
        new_name: data.new_file_name,
        file_dir: data.file_dir,
        upload_date: data.upload_date,
        ins_date: data.ins_date,
      };
    });

    console.log("result.data", datas);

    setRows(datas);

    setPagination(result.data.pagination);
  };

  useEffect(() => {
    getUploadFileList(props.path);
  }, [page,props.path]);

  const goPage = (clickPage: any) => {
    setPage(clickPage);
  };

  function CustomFooter() {
    return (
      <GridFooterContainer sx={{ display: "flex", justifyContent: "center" }}>
        {pagination !== undefined ? (
          <CustomPagination pagination={pagination} goPage={goPage} />
        ) : ""}
      </GridFooterContainer>
    );
  }

  return (
    <Box>
      <React.Fragment>
      <Typography component="h2" variant="h6" color="#000" gutterBottom>{props.path ? "[" + props.path + "]" : ""}  파일 목록</Typography>

        <ThemeProvider theme={theme}>
          <div style={{ height: "94vh", width: "100%" }}>
            <DataGrid
              editMode="row"
              rows={rows}
              columns={columns}
              checkboxSelection
              pageSize={100}
              components={{ Toolbar: CustomToolbar, Footer: CustomFooter }}
              componentsProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
              getRowId={(row) => row.id}
              localeText={koKRGrid}
              experimentalFeatures={{ newEditingApi: true }}
            />
          </div>
        </ThemeProvider>
      </React.Fragment>
    </Box>
  );
};

export default FileInfoTable;
